import { Grid } from '@mui/material';
import { ISubmissionSettingsResponse } from 'wisestep-api';

import ExEmployeeClientFormFileds from './ExEmployeeClientFormFileds';
import SkillMatrix from './SkillMatrix';

const SubmissionFormNewFields = ({
  submissionSetting,
}: {
  submissionSetting: ISubmissionSettingsResponse;
}) => {
  return (
    <Grid mb={3}>
      {submissionSetting?.skillMatrix && !submissionSetting?.skillMatrix?.hidden && (
        <SkillMatrix
          name="skillMatrixRatings"
          showMandatorySymbol={submissionSetting?.skillMatrix?.required ?? false}
        />
      )}
      <ExEmployeeClientFormFileds submissionSetting={submissionSetting} />
    </Grid>
  );
};

export default SubmissionFormNewFields;
